export type AnalyticsEvent = Readonly<{
  name:
    | "onboarding_started"
    | "onboarding_step_viewed"
    | "onboarding_completed"
    | "login_started"
    | "login_method_selected"
    | "login_sso_selected"
    | "login_completed";
  method?: "email" | "phone" | "google" | "microsoft";
  stepId?: string;
}>;
export interface Analytics {
  track(event: AnalyticsEvent): void;
}
export const noOpAnalytics: Analytics = { track: () => undefined };

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export function initializeGoogleTagManager(containerId: string | undefined): Analytics {
  if (!containerId || typeof document === "undefined") return noOpAnalytics;
  window.dataLayer ??= [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}`;
  script.dataset.petchefGtm = containerId;
  document.head.append(script);
  return {
    track: (event) => {
      window.dataLayer?.push({ event: event.name, method: event.method, step_id: event.stepId });
    },
  };
}
